import { Button } from "newui/components/Button"
import { navigate } from "@reach/router";

export const ReturnToLoginButton = ({ isLoading }: { isLoading?: boolean }) => {
	return <Button className="mt-2" type="button" btntype={'secondary'} isLoading={isLoading} onClick={() => navigate('./login')} width={"full"}>Return to Login Screen</Button>
}